export const siteContent = {
  de: {
    meta: {
      title: 'Leon Dietsche | Portfolio für Immobilienbewirtschaftung, Software und Fintech',
      description:
        'Portfolio von Leon Dietsche mit Fokus auf Immobilienbewirtschaftung, Softwareentwicklung, Projekten und fintech-nahem Fachwissen.'
    },
    navigation: {
      items: [
        { name: 'Profil', href: '#about' },
        { name: 'Kompetenzen', href: '#skills' },
        { name: 'Erfahrung', href: '#experience' },
        { name: 'Projekte', href: '#projects' },
        { name: 'Blog', href: '#blog' },
        { name: 'Ausbildung', href: '#education' },
        { name: 'Kontakt', href: '#contact' }
      ],
      languageLabel: 'Sprache'
    },
    hero: {
      subtitle: 'Softwareentwicklung & Immobilienbewirtschaftung',
      description: 'Technologie und Immobilieninnovation verbinden.',
      primaryCta: 'Mehr erfahren',
      secondaryCta: 'Blog ansehen',
      secondaryHref: '#blog',
      imageAlt: 'Leon Dietsche'
    },
    about: {
      title: 'Profil',
      paragraphs: [
        'Ich bin ein leidenschaftlicher Softwareentwickler mit einer Kombination aus technischem Fachwissen und Immobilienverständnis.',
        'Mein Hintergrund verbindet fundiertes Immobilienwissen mit mehreren Jahren praktischer Programmiererfahrung. Dadurch denke ich strukturiert, baue gerne selbst und erkenne schnell, wo digitale Lösungen echten Mehrwert schaffen.',
        'Mit der Rhealis AG ist bereits der erste unternehmerische Schritt gesetzt. Gleichzeitig soll dieses Portfolio bewusst auch die anderen Bereiche zeigen, die mich antreiben, besonders Programmierung, technische Umsetzung und die Bereitschaft, über Zeit mehr herauszuholen als andere.'
      ],
      factsTitle: 'Kurzprofil',
      facts: [
        { label: 'Standort', value: 'St. Gallen, Schweiz' },
        { label: 'Aktuelle Rolle', value: 'Rhealis AG + eigene Projekte' },
        { label: 'Positionierung', value: 'Immobilien + Software' },
        { label: 'Fokus', value: 'Management + Programming' }
      ]
    },
    skills: {
      title: 'Kompetenzen',
      coreTitle: 'Kernkompetenzen',
      toolkitTitle: 'Operatives und technisches Toolkit',
      skills: [
        {
          name: 'Immobilienbewirtschaftung',
          level: 95,
          description: 'Operative Führung, Koordination, Servicequalität und verlässliche Umsetzung'
        },
        {
          name: 'Softwareentwicklung',
          level: 91,
          description: 'Starker Hintergrund in Programmierung, Business-Anwendungen sowie Frontend und Backend'
        },
        {
          name: 'Prozessoptimierung',
          level: 88,
          description: 'Strukturierte Workflows, klare Prioritäten und praktische Verbesserungen'
        },
        {
          name: 'JavaScript / React',
          level: 86,
          description: 'Moderne Webentwicklung, komponentenbasierte Interfaces und saubere Umsetzung'
        },
        {
          name: 'Fintech-Know-how',
          level: 76,
          description: 'Verständnis für Finanzsysteme, Unternehmenslogik und datengetriebene Prozesse'
        }
      ],
      technologies: [
        'Immobilienbewirtschaftung',
        'React / JavaScript',
        'Java',
        'Python',
        'MSSQL / SQL',
        'API-Integration',
        'Prozessdesign',
        'Marktanalyse'
      ],
      focusTitle: 'Arbeitsfokus',
      focusItems: [
        'Immobilienbewirtschaftung als operatives Kernthema',
        'Starke Programmierfähigkeiten für moderne Business-Anwendungen',
        'Technologie dort einsetzen, wo sie Prozesse wirklich verbessert',
        'Fintech-Verständnis aus der Arbeit mit Enterprise-Finanzsystemen'
      ]
    },
    experience: {
      title: 'Erfahrung',
      items: [
        {
          title: 'Gründer',
          company: 'Rhealis AG',
          duration: 'Heute',
          location: 'St. Gallen, Schweiz',
          technologies: ['Immobilienbewirtschaftung', 'Operations', 'Strategie', 'Prozessverbesserung'],
          description:
            'Rhealis AG gegründet mit klarem Fokus auf Immobilienbewirtschaftung. Im Zentrum stehen operative Verlässlichkeit, saubere Prozesse und der Aufbau eines Unternehmens, das mit Qualität, Disziplin und Umsetzung überzeugt.'
        },
        {
          title: 'Software Developer',
          company: 'Arvato Financial Solutions',
          duration: 'November 2021 - Dezember 2025',
          location: 'Schlieren, Zürich, Schweiz',
          technologies: ['Java', 'JavaScript', 'MSSQL', 'Financial Systems'],
          description:
            'Entwicklung und Weiterentwicklung von Finanzsoftware in einem Enterprise-Umfeld. Diese Zeit hat meine technische Tiefe, mein Verständnis für komplexe Geschäftslogik und mein fintech-nahes Wissen entscheidend geprägt.'
        },
        {
          title: 'Software Engineer Web Development',
          company: 'MF Group AG',
          duration: 'Juli 2020 - Oktober 2021',
          location: 'St. Gallen, Schweiz',
          technologies: ['PHP', 'F3-Framework', 'Composer'],
          description:
            'Arbeit an internen und externen Webanwendungen im Frontend und Backend. Dabei habe ich praktische Erfahrung in sauberer Implementierung, Wartung und produktiver Auslieferung gesammelt.'
        },
        {
          title: 'Praktikant Softwareentwicklung',
          company: 'Universität St. Gallen (HSG)',
          duration: 'Oktober 2018',
          location: 'St. Gallen, Schweiz',
          technologies: ['C#'],
          description:
            'Praktikum mit Fokus auf algorithmisches Denken, Problemlösung und softwareseitige Struktur.'
        },
        {
          title: 'Praktikant Softwareentwicklung',
          company: 'EGELI Informatik AG',
          duration: 'September 2018',
          location: 'St. Gallen, Schweiz',
          technologies: ['C#'],
          description:
            'Praktikum mit Schwerpunkt auf C#-Entwicklung und sauberen Software-Grundlagen.'
        }
      ]
    },
    projects: {
      title: 'Projekte',
      intro:
        'Ausgewählte Projekte, die zeigen, wie ich technische Themen strukturiert angehe und Lösungen sauber umsetze.',
      featuresTitle: 'Schwerpunkte',
      linkLabel: 'Auf GitHub ansehen',
      items: [
        {
          title: 'Real Estate Scraper',
          technology: 'Python',
          description:
            'Automatisiertes System zur Datensammlung für Immobilienanalysen. Entwickelt, um Marktdaten effizient auszuwerten und bessere Entscheidungsgrundlagen zu schaffen.',
          features: ['Web Scraping', 'Datenverarbeitung', 'Marktanalyse', 'Automatisierte Reports'],
          github: 'https://github.com/LeonDietsche/real-estate-scraper'
        },
        {
          title: 'Jarvis Assistant',
          technology: 'Python',
          description:
            'Sprachgesteuerter Assistent, der Automatisierung, strukturierte Befehlsverarbeitung und praktische Arbeitserleichterung durch Software zeigt.',
          features: ['Spracherkennung', 'NLP', 'Task Automation', 'Machine Learning'],
          github: 'https://github.com/LeonDietsche/jarvis-assistant'
        },
        {
          title: 'Maria Studio',
          technology: 'JavaScript',
          description:
            'Full-Stack-Webanwendung als Beispiel für moderne Webarchitektur, Interface-Design und durchgängige technische Umsetzung.',
          features: ['Full-Stack-Entwicklung', 'API-Integration', 'Responsive Design', 'Modernes JavaScript'],
          github: 'https://github.com/LeonDietsche/mariastudio'
        }
      ]
    },
    blog: {
      title: 'Blog',
      intro:
        'Ein Bereich für Gedanken, Learnings und Einblicke aus Immobilienbewirtschaftung, Softwareentwicklung und aktuellen Themen mit praktischer Relevanz.',
      readLabel: 'Beitrag lesen',
      closeLabel: 'Schließen',
      directLinkLabel: 'Direktlink',
      backLabel: 'Zurück zum Portfolio',
      notFoundTitle: 'Beitrag nicht gefunden',
      notFoundText: 'Der gewünschte Blogbeitrag konnte nicht gefunden werden.',
      emptyLabel: 'Neue Beiträge lassen sich jederzeit über die Datenstruktur ergänzen.',
    },
    education: {
      title: 'Ausbildung',
      intro: 'Immobilienbewirtschaftung mit einer belastbaren technischen Grundlage.',
      currentLabel: 'Aktuell',
      perspectiveTitle: 'Operative und technische Perspektive',
      perspectiveText:
        'Meine Ausbildung verbindet Immobilienbewirtschaftung mit technischem Verständnis. Genau diese Kombination hilft mir dabei, Prozesse realistisch zu beurteilen und digitale Verbesserungen sinnvoll einzusetzen.',
      items: [
        {
          degree: 'Sachbearbeiter Immobilien Bewirtschaftung',
          school: 'KV Business School Zürich',
          duration: '2024 - 2025',
          grade: 'Note 5 (Schweizer Notensystem)',
          focus: 'Property management, real estate operations, market analysis und regulatorische Grundlagen',
          current: false
        },
        {
          degree: 'Grundausbildung Applikationsentwickler EFZ',
          school: 'Informatikmittelschule St. Gallen am Brühl',
          duration: 'Juli 2017 - Juli 2021',
          grade: 'Abgeschlossen',
          focus: 'Business Informatics, Applikationsentwicklung und softwaretechnische Grundlagen',
          current: false
        }
      ]
    },
    contact: {
      title: 'Kontakt',
      intro:
        'Wenn Sie über Immobilienbewirtschaftung, digitale Prozesse oder technische Projekte sprechen möchten, freue ich mich auf den Austausch.',
      touchTitle: 'Kontaktaufnahme',
      touchText:
        'Offen für Gespräche rund um Immobilienbewirtschaftung, Softwareentwicklung und praxisnahe digitale Lösungen. Ob Mandat, Projekt oder strategischer Austausch: Kontaktieren Sie mich gerne.',
      emailLabel: 'E-Mail',
      locationLabel: 'Standort',
      locationValue: 'St. Gallen, Schweiz',
      interestTitle: 'Themen',
      interests: [
        'Mandate in der Immobilienbewirtschaftung',
        'Programmierung und Webentwicklung',
        'Operative Qualität und Struktur',
        'Digitale Prozessverbesserung',
        'PropTech-Zusammenarbeit',
        'Fintech-nahe Produkt- und Prozessfragen'
      ],
      form: {
        name: 'Name',
        email: 'E-Mail',
        subject: 'Betreff',
        message: 'Nachricht',
        submit: 'Nachricht senden'
      }
    },
    footer: {
      tagline: 'Immobilienbewirtschaftung | Softwareentwicklung | Fintech-Know-how',
      emailLabel: 'E-Mail',
      copyright: 'Alle Rechte vorbehalten.',
      location: 'St. Gallen, Schweiz'
    }
  },
  en: {
    meta: {
      title: 'Leon Dietsche | Portfolio for Real Estate, Software, and Fintech',
      description:
        'Portfolio of Leon Dietsche with a focus on real estate management, software development, projects, and fintech-related knowledge.'
    },
    navigation: {
      items: [
        { name: 'About', href: '#about' },
        { name: 'Skills', href: '#skills' },
        { name: 'Experience', href: '#experience' },
        { name: 'Projects', href: '#projects' },
        { name: 'Blog', href: '#blog' },
        { name: 'Education', href: '#education' },
        { name: 'Contact', href: '#contact' }
      ],
      languageLabel: 'Language'
    },
    hero: {
      subtitle: 'Software Developer & Real Estate Management',
      description: 'Bridging Technology and Real Estate Innovation',
      primaryCta: 'Learn More',
      secondaryCta: 'View Blog',
      secondaryHref: '#blog',
      imageAlt: 'Leon Dietsche'
    },
    about: {
      title: 'About',
      paragraphs: [
        'I\'m a passionate software developer with a combination of technical expertise and real estate insight.',
        'My background combines formal real estate training with several years of hands-on programming experience. That helps me think in systems, build things myself, and spot where digital tools create real value.',
        'Rhealis AG is one important part of that path, but not the whole story. I also want this site to show the other side clearly: programming, technical execution, and the drive to keep improving faster than most people are willing to.'
      ],
      factsTitle: 'Quick Facts',
      facts: [
        { label: 'Location', value: 'St. Gallen, Switzerland' },
        { label: 'Current Focus', value: 'Rhealis AG + personal projects' },
        { label: 'Positioning', value: 'Real Estate + Software' },
        { label: 'Focus', value: 'Management + Programming' }
      ]
    },
    skills: {
      title: 'Skills',
      coreTitle: 'Core Strengths',
      toolkitTitle: 'Operational & Technical Toolkit',
      skills: [
        {
          name: 'Real Estate Management',
          level: 95,
          description: 'Operational leadership, coordination, service quality, and dependable execution'
        },
        {
          name: 'Software Development',
          level: 91,
          description: 'Strong programming background across business applications, frontend, and backend'
        },
        {
          name: 'Process Optimization',
          level: 88,
          description: 'Structured workflows, clear prioritization, and practical improvement'
        },
        {
          name: 'JavaScript / React',
          level: 86,
          description: 'Modern web development, component-based interfaces, and solid implementation'
        },
        {
          name: 'Fintech Knowledge',
          level: 76,
          description: 'Understanding of financial systems, enterprise logic, and data-driven processes'
        }
      ],
      technologies: [
        'Property Management',
        'React / JavaScript',
        'Java',
        'Python',
        'MSSQL / SQL',
        'API Integration',
        'Process Design',
        'Market Analysis'
      ],
      focusTitle: 'Focus Areas',
      focusItems: [
        'Real estate management as the operational core',
        'Strong programming skills for modern business applications',
        'Technology applied where it genuinely improves processes',
        'Fintech understanding from work with enterprise financial systems'
      ]
    },
    experience: {
      title: 'Experience',
      items: [
        {
          title: 'Founder',
          company: 'Rhealis AG',
          duration: 'Present',
          location: 'St. Gallen, Switzerland',
          technologies: ['Real Estate Management', 'Operations', 'Leadership', 'Process Improvement'],
          description:
            'Founded Rhealis AG with a clear focus on real estate management. The work is centered on operational reliability, strong processes, and building a company that earns trust through discipline and execution.'
        },
        {
          title: 'Software Developer',
          company: 'Arvato Financial Solutions',
          duration: 'November 2021 - December 2025',
          location: 'Schlieren, Zurich, Switzerland',
          technologies: ['Java', 'JavaScript', 'MSSQL', 'Financial Systems'],
          description:
            'Developed and maintained financial software in an enterprise environment. This period significantly deepened my technical skill set, my understanding of complex business logic, and my fintech-related knowledge.'
        },
        {
          title: 'Software Engineer Web Development',
          company: 'MF Group AG',
          duration: 'July 2020 - October 2021',
          location: 'St. Gallen, Switzerland',
          technologies: ['PHP', 'F3-Framework', 'Composer'],
          description:
            'Worked on internal and external web applications across frontend and backend. This built strong hands-on experience in implementation, maintenance, and production delivery.'
        },
        {
          title: 'Software Development Intern',
          company: 'University of St. Gallen (HSG)',
          duration: 'October 2018',
          location: 'St. Gallen, Switzerland',
          technologies: ['C#'],
          description:
            'Internship focused on algorithmic thinking, problem-solving, and structured software work.'
        },
        {
          title: 'Software Development Intern',
          company: 'EGELI Informatik AG',
          duration: 'September 2018',
          location: 'St. Gallen, Switzerland',
          technologies: ['C#'],
          description:
            'Internship focused on C# development and strong software fundamentals.'
        }
      ]
    },
    projects: {
      title: 'Projects',
      intro:
        'Selected projects that show how I approach technical problems in a structured way and turn ideas into working solutions.',
      featuresTitle: 'Focus Areas',
      linkLabel: 'View on GitHub',
      items: [
        {
          title: 'Real Estate Scraper',
          technology: 'Python',
          description:
            'Automated data collection system for real estate analysis, built to process market data efficiently and support better decisions.',
          features: ['Web Scraping', 'Data Processing', 'Market Analysis', 'Automated Reports'],
          github: 'https://github.com/LeonDietsche/real-estate-scraper'
        },
        {
          title: 'Jarvis Assistant',
          technology: 'Python',
          description:
            'Voice-driven assistant that demonstrates automation, structured command handling, and practical software support for recurring tasks.',
          features: ['Voice Recognition', 'NLP', 'Task Automation', 'Machine Learning'],
          github: 'https://github.com/LeonDietsche/jarvis-assistant'
        },
        {
          title: 'Maria Studio',
          technology: 'JavaScript',
          description:
            'Full-stack web application that showcases modern web architecture, interface design, and end-to-end implementation.',
          features: ['Full-Stack Development', 'API Integration', 'Responsive Design', 'Modern JavaScript'],
          github: 'https://github.com/LeonDietsche/mariastudio'
        }
      ]
    },
    blog: {
      title: 'Blog',
      intro:
        'A place for thoughts, learnings, and short write-ups on real estate management, software development, and current topics with practical relevance.',
      readLabel: 'Read post',
      closeLabel: 'Close',
      directLinkLabel: 'Direct link',
      backLabel: 'Back to portfolio',
      notFoundTitle: 'Post not found',
      notFoundText: 'The requested blog post could not be found.',
      emptyLabel: 'New posts can be added anytime through the content structure.',
    },
    education: {
      title: 'Education',
      intro: 'Real estate knowledge supported by a strong technical foundation.',
      currentLabel: 'Current',
      perspectiveTitle: 'Operational and Technical Perspective',
      perspectiveText:
        'My educational path combines real estate management with technical understanding. That combination helps me evaluate processes realistically and improve them with the right digital tools.',
      items: [
        {
          degree: 'Real Estate Management Specialist',
          school: 'KV Business School Zürich',
          duration: '2024 - 2025',
          grade: 'Grade 5 (Swiss grading system)',
          focus: 'Property management, real estate operations, market analysis, and regulatory fundamentals',
          current: false
        },
        {
          degree: 'Application Developer EFZ',
          school: 'Informatikmittelschule St. Gallen am Brühl',
          duration: 'July 2017 - July 2021',
          grade: 'Completed',
          focus: 'Business informatics, application development, and software engineering fundamentals',
          current: false
        }
      ]
    },
    contact: {
      title: 'Contact',
      intro:
        'If you would like to discuss real estate management, digital processes, or technical projects, I would be glad to connect.',
      touchTitle: 'Get In Touch',
      touchText:
        'I am open to conversations around real estate management, software development, and practical digital solutions. Whether it is a mandate, a project, or a strategic exchange, feel free to reach out.',
      emailLabel: 'Email',
      locationLabel: 'Location',
      locationValue: 'St. Gallen, Switzerland',
      interestTitle: 'Topics',
      interests: [
        'Real estate management mandates',
        'Programming and web development projects',
        'Operational quality and structure',
        'Digital process improvement',
        'PropTech collaboration',
        'Fintech-related product and process discussions'
      ],
      form: {
        name: 'Name',
        email: 'Email',
        subject: 'Subject',
        message: 'Message',
        submit: 'Send Message'
      }
    },
    footer: {
      tagline: 'Real Estate Management | Software Development | Fintech Knowledge',
      emailLabel: 'Email',
      copyright: 'All rights reserved.',
      location: 'St. Gallen, Switzerland'
    }
  }
};
